/** Short format with weekday: e.g. "lun. 16 feb." / "mar, 15 sept". */
export const shortDateFormatWithWeekday = {
  weekday: 'short' as const,
  month: 'short' as const,
  day: 'numeric' as const,
};

/** Capitalizes only the first character (e.g. "lun. 16 feb." → "Lun. 16 feb."). */
export function capitalizeFirstLetter(str: string): string {
  if (!str) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Returns the calendar day of month (1–31) for `date` interpreted in `timeZone`.
 * Used to keep labels aligned with DayPicker selection in the station zone.
 */
export function getCalendarDayInTimezone(date: Date, timeZone: string): number {
  const day = new Intl.DateTimeFormat('en-US', { timeZone, day: 'numeric' }).format(date);
  return Number(day);
}

/**
 * Formats a date as short weekday + month + day in the given timezone, then capitalizes.
 * Always pass the station timezone — formatting without it uses the browser zone and can
 * show the previous/next calendar day when browser TZ ≠ station TZ.
 */
export function formatShortDateInTimezone(date: Date, timeZone: string, locale: string): string {
  const formatted = new Intl.DateTimeFormat(locale, {
    ...shortDateFormatWithWeekday,
    timeZone,
  }).format(date);

  return capitalizeFirstLetter(formatted);
}
